module.exports = __webpack_public_path__ + "static/media/jp.2209fcab.svg";